import React, { useState } from 'react';
import { makeStyles, Button, TextField, InputAdornment } from '@material-ui/core';
import { ListOutlined, AddOutlined, DehazeOutlined, FiberManualRecord } from '@material-ui/icons';
import { useForm, Controller } from 'react-hook-form';

export const ListsForm = () => {

    const [ items, setItems ] = useState([0]);
    const classes = useStyles();
    const { handleSubmit, control, errors } = useForm();

    const handleAddItem = () => {
        setItems(e => ([...e, e+1]) );
    }

    return (
        <form className={classes.form}>
            <div className={classes.container}>
                <section className={classes.title}>
                    <ListOutlined htmlColor='rgba(0, 0, 0, .5)' />
                    <h3 className={classes.text}>Listas de información</h3>
                </section>

                <div className={classes.containerGroup}>
                    <label className={classes.label}>Item</label>

                    <Controller
                        name='title'
                        control={control}
                        //defaultValue={state?.lists?.title}
                        render={({ onChange, value }) => (
                            <TextField
                                //disabled={isLoading}
                                error={errors.title ? true : false}
                                label='Titulo'
                                helperText={errors.title ? errors.title.message : 'Ingrese el titulo del contenido'}
                                size='small'
                                variant="outlined"
                                style={{ marginBottom: 15, background: '#fff', width: 500 }}
                                value={value}
                                onChange={onChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <DehazeOutlined htmlColor='grey' />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                        rules={{
                            pattern: {
                                //value: /^https\:\/\/w{3}\.youtube\.com\/embed\/[a-zA-Z0-9]+[\S]$/g,
                                //message: 'La url no es correcta'
                            },
                        }}
                    />

                    <div className={classes.containerLists}>
                        <div className={classes.list}>
                            { items.map((item, key) => (
                                <Controller
                                    key={key}
                                    name='lista1'
                                    control={control}
                                    //defaultValue={state?.lists?.title}
                                    render={({ onChange, value }) => (
                                        <TextField
                                            //disabled={isLoading}
                                            error={errors.lista1 ? true : false}
                                            label='Lista 1'
                                            //helperText={errors.lista1 ? errors.lista1.message : 'Ingrese el texto'}
                                            size='small'
                                            variant="outlined"
                                            style={{ marginBottom: 0, background: '#fff', width: 400 }}
                                            value={value}
                                            onChange={onChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FiberManualRecord htmlColor='grey' fontSize='small' />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                    rules={{
                                        pattern: {
                                            //value: /^https\:\/\/w{3}\.youtube\.com\/embed\/[a-zA-Z0-9]+[\S]$/g,
                                            //message: 'La url no es correcta'
                                        },
                                    }}
                                />
                            )) }
                            <div className={classes.btnAdd} onClick={ handleAddItem }>
                                <AddOutlined htmlColor='grey' />
                            </div>
                        </div>
                    </div>

                    <Controller
                        name='pie'
                        control={control}
                        //defaultValue={state?.lists?.title}
                        render={({ onChange, value }) => (
                            <TextField
                                //disabled={isLoading}
                                error={errors.pie ? true : false}
                                label='Pie'
                                helperText={errors.pie ? errors.pie.message : 'Ingrese el pie del contenido'}
                                size='small'
                                variant="outlined"
                                style={{ marginTop: 20, background: '#fff', width: 500 }}
                                value={value}
                                onChange={onChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <DehazeOutlined htmlColor='grey' />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                        rules={{
                            pattern: {
                                //value: /^https\:\/\/w{3}\.youtube\.com\/embed\/[a-zA-Z0-9]+[\S]$/g,
                                //message: 'La url no es correcta'
                            },
                        }}
                    />
                </div>

                <Button
                    variant="contained"
                    style={{ background: '#4caf50', color: '#fff', marginBottom: 20 }}
                >
                    <AddOutlined fontSize='small' /> 
                </Button>
            </div>
        </form>
    )
}

const useStyles = makeStyles({
    form: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    container: {
        background: '#fff',
        marginTop: 0,
        marginBottom: 10,
        borderRadius: 6,
        paddingLeft: 20,
        paddingRight: 20
    },
    title: {
        display: 'flex',
        alignItems: 'center'
    },
    text: {
        color: 'rgba(0, 0, 0, .5)',
        marginLeft: 10
    },
    containerGroup: {
        borderStyle: 'solid',
        borderWidth: 1.5,
        borderColor: '#bdbdbd',
        borderRadius: 4,
        paddingTop: 30,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        position: 'relative',
        marginBottom: 20
    },
    label: {
        position: 'absolute',
        top: -10,
        fontSize: 13,
        color: '#757575',
        backgroundColor: '#fff',
        paddingLeft: 5,
        paddingRight: 5
    },
    containerLists: {
        width: 500,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    list: {
        display: 'flex',
        flexDirection: 'column'
    },
    btnAdd: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 5,
        cursor: 'pointer'
    }
});